var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("入库管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("待审核退货")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("订单详情")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderType" }, [
        _c("div", { staticClass: "head" }, [
          _vm._v("订单状态: " + _vm._s(_vm.type[_vm.data.type])),
        ]),
        _c("div", { staticClass: "context" }, [
          _c("div", { staticClass: "top" }, [
            _c("span", [_vm._v("下单时间: " + _vm._s("2020-05-06 14:25:22"))]),
            _c("span", [_vm._v("发货时间: " + _vm._s("2020-05-06 17:25:22"))]),
            _c("span", [_vm._v("签收时间: " + _vm._s("无"))]),
          ]),
          _c("div", { staticClass: "middle" }, [
            _c("span", [_vm._v("物流信息: ")]),
            _c("span", { staticStyle: { color: "#4A90E4" } }, [
              _vm._v(_vm._s("商品已由广州分部发出，下一站，苏州分部。")),
            ]),
            _c(
              "span",
              {
                staticStyle: {
                  width: "300px",
                  "min-width": "200px",
                  "padding-left": "40px",
                },
              },
              [_vm._v(_vm._s("2020-05-07 09:14:00"))]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "orderType" }, [
        _c("div", { staticClass: "head" }, [_vm._v("收货人信息")]),
        _c("div", { staticClass: "context" }, [
          _c("div", { staticClass: "top" }, [
            _c("span", [_vm._v("收货人姓名: " + _vm._s("张仲元"))]),
            _c("span", [_vm._v("联系电话: " + _vm._s(15290889088))]),
            _c("span", [_vm._v("收货地区: " + _vm._s("北京-宣武区"))]),
          ]),
          _c("div", { staticClass: "middle" }, [
            _c("span", [
              _vm._v("详细地址: " + _vm._s("北京宣武区北纬路甲一号")),
            ]),
          ]),
          _c("div", { staticClass: "bottom" }, [
            _c("span", [_vm._v("备注: " + _vm._s("无"))]),
          ]),
        ]),
      ]),
      _c(
        "div",
        [
          _c("div", { staticClass: "returnGoods" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "tableHead" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#2d7edf",
                            "font-weight": "400",
                          },
                        },
                        [_c("span", [_vm._v("商品名称")])]
                      ),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c("div", { staticClass: "grid-content" }, [
                        _c("span", [_vm._v("商品数量")]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c("div", { staticClass: "grid-content" }, [
                        _c("span", [_vm._v("商品单价")]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c("div", { staticClass: "grid-content" }, [
                        _c("span", [_vm._v("商品规格")]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c("div", { staticClass: "grid-content" }, [
                        _c("span", [_vm._v("商品小计")]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._l(_vm.data.goods, function (item, index) {
            return _c(
              "div",
              { staticClass: "returnGood" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", [
                        _c("span", [_vm._v(" " + _vm._s(item.name) + " ")]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "grid-content",
                          staticStyle: { "padding-right": "40px" },
                        },
                        [_c("span", [_vm._v(" " + _vm._s(item.count) + " ")])]
                      ),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "grid-content",
                          staticStyle: { "padding-right": "20px" },
                        },
                        [_c("span", [_vm._v(" " + _vm._s(item.price) + "元 ")])]
                      ),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c("div", { staticClass: "grid-content" }, [
                        _c("span", [
                          _vm._v(_vm._s(item.specification) + "g/盒"),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 3 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "grid-content",
                          staticStyle: { "padding-right": "30px" },
                        },
                        [
                          _c("span", [
                            _vm._v(" " + _vm._s(item.subtotal) + " "),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "div",
            { staticClass: "total", staticStyle: { "margin-bottom": "10px" } },
            [
              _c("div", { staticClass: "context" }, [
                _c("span", [
                  _vm._v("总计: 共" + _vm._s(_vm.data.goods.length) + "件"),
                ]),
                _c("span", [_vm._v("运费: " + _vm._s(0))]),
                _c("span", [_vm._v("总价: " + _vm._s(_vm.totalPrice))]),
              ]),
            ]
          ),
        ],
        2
      ),
      _vm.data.typeNum === 2
        ? _c(
            "div",
            [
              _c("div", { staticClass: "returnGoods" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "tableHead" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#2d7edf",
                                "font-weight": "400",
                              },
                            },
                            [_c("span", [_vm._v("商品名称")])]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [_vm._v("商品数量")]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [_vm._v("商品单价")]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [_vm._v("商品规格")]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [_vm._v("商品小计")]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._l(_vm.data.goods, function (item, index) {
                return _c(
                  "div",
                  { staticClass: "returnGood" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", [
                            _c("span", [_vm._v(" " + _vm._s(item.name) + " ")]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: { "padding-right": "40px" },
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(item.count) + " "),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: { "padding-right": "20px" },
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(item.price) + "元 "),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("span", [
                              _vm._v(_vm._s(item.specification) + "g/盒"),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: { "padding-right": "30px" },
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(item.subtotal) + " "),
                              ]),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "total" }, [
                _c("div", { staticClass: "context" }, [
                  _c("span", [
                    _vm._v("总计: 共" + _vm._s(_vm.data.goods.length) + "件"),
                  ]),
                  _c("span", [_vm._v("运费: " + _vm._s(0))]),
                  _c("span", [_vm._v("总价: " + _vm._s(_vm.totalPrice))]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "operation" }, [
        _c("div", { staticClass: "context" }, [
          !_vm.data.typeNum
            ? _c("button", { staticClass: "button" }, [_vm._v("同意退货")])
            : _vm._e(),
          !_vm.data.typeNum
            ? _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      _vm.dowith = true
                    },
                  },
                },
                [_vm._v(" 驳回 ")]
              )
            : _vm._e(),
          _vm.data.typeNum == 1
            ? _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      _vm.dowith = true
                    },
                  },
                },
                [_vm._v(" 确认收货 ")]
              )
            : _vm._e(),
          _vm.data.typeNum == 2
            ? _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      _vm.dowith = true
                    },
                  },
                },
                [_vm._v(" 提交财务 ")]
              )
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "record" }, [
        _c("div", { staticClass: "nav" }, [
          _c(
            "div",
            {
              staticClass: "text",
              style:
                _vm.activeIndex == 1
                  ? "border-bottom: 2px solid #2d7edf;color: #2d7edf;"
                  : "",
              on: {
                click: function ($event) {
                  return _vm.activeUpdate(1)
                },
              },
            },
            [_c("span", [_vm._v("订单修改记录")])]
          ),
          _c(
            "div",
            {
              staticClass: "text",
              style:
                _vm.activeIndex == 2
                  ? "border-bottom: 2px solid #2d7edf;color: #2d7edf;"
                  : "",
              on: {
                click: function ($event) {
                  return _vm.activeUpdate(2)
                },
              },
            },
            [_c("span", [_vm._v("物流记录")])]
          ),
        ]),
        _c(
          "div",
          { staticClass: "tableHead" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 9 } }, [
                  _c(
                    "div",
                    { staticStyle: { color: "#2d7edf", "font-weight": "400" } },
                    [_c("span", [_vm._v("修改记录")])]
                  ),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v("记录人员")]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v("进度时间")]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v("审核人员")]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v("审核时间")]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v("审核状态")]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "recordContext" }, [
        _c(
          "div",
          { staticClass: "tableHead" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 9 } }, [
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s("老班章古树纯料普洱茶换成珍藏品品普洱")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("span", [_vm._v(_vm._s("小铃铛"))]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "grid-content",
                      staticStyle: {
                        "flex-direction": "column",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s("2020/05/06"))]),
                      _c("span", [_vm._v(_vm._s("14:25:06"))]),
                    ]
                  ),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "grid-content",
                      staticStyle: {
                        "flex-direction": "column",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s("经理"))]),
                      _c("span", [_vm._v(_vm._s("文员"))]),
                      _c("span", [_vm._v(_vm._s("物流"))]),
                    ]
                  ),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "grid-content",
                      staticStyle: {
                        "flex-direction": "column",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s("2020/05/06"))]),
                      _c("span", [_vm._v(_vm._s("14:25:06"))]),
                    ]
                  ),
                ]),
                _c("el-col", { attrs: { span: 3 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "grid-content",
                      staticStyle: {
                        "flex-direction": "column",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s("已通过"))]),
                      _c("span", [_vm._v(_vm._s("已通过"))]),
                      _c("span", [_vm._v(_vm._s("待审核"))]),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.data.typeNum == 1
        ? _c(
            "el-dialog",
            {
              staticClass: "twoDialog",
              attrs: {
                visible: _vm.dowith,
                "append-to-body": true,
                "show-close": false,
                width: "70%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dowith = $event
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("待收货商品")]),
              _c(
                "div",
                { staticClass: "tableHead" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 9 } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#2d7edf",
                              "font-weight": "400",
                            },
                          },
                          [_c("span", [_vm._v("修改记录")])]
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("span", [_vm._v("记录人员")]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("span", [_vm._v("进度时间")]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 3 } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("span", [_vm._v("审核人员")]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("span", [_vm._v("审核时间")]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.data.goods, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "tableHead" },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: { gutter: 20 },
                      },
                      [
                        _c("el-col", { attrs: { span: 9 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#676767",
                                "font-weight": "400",
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(item.name))])]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: {
                                color: "#676767",
                                "padding-right": "20px",
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(item.price) + "元")])]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: {
                                color: "#676767",
                                "padding-right": "5px",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(item.specification) + "g/盒"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: { color: "#676767" },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, size: "mini" },
                                model: {
                                  value: item.count,
                                  callback: function ($$v) {
                                    _vm.$set(item, "count", $$v)
                                  },
                                  expression: "item.count",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "grid-content",
                              staticStyle: { color: "#676767" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.value,
                                    callback: function ($$v) {
                                      _vm.value = $$v
                                    },
                                    expression: "value",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#2d7edf",
                    position: "absolute",
                    right: "50px",
                    "margin-top": "10px",
                  },
                },
                [
                  _c("span", { staticStyle: { "margin-right": "10px" } }, [
                    _vm._v("总共: 共" + _vm._s(_vm.data.goods.length) + "件"),
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        "margin-right": "20px",
                      },
                    },
                    [_vm._v("运费: " + _vm._s(0))]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.dowith = false
                        },
                      },
                    },
                    [_vm._v(" 确认收货 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.dowith = false
                        },
                      },
                    },
                    [_vm._v("异常审核")]
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
      !_vm.data.typeNum
        ? _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dowith, "append-to-body": true },
              on: {
                "update:visible": function ($event) {
                  _vm.dowith = $event
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    "line-height": "30px",
                  },
                },
                [_vm._v("请填写驳回原因:")]
              ),
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入内容" },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dowith = false
                        },
                      },
                    },
                    [_vm._v("确 认")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dowith = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { height: "50px" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "head" }, [
      _c("span", [_vm._v("退货商品")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "head" }, [
      _c("span", [_vm._v("实际退回商品")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }